import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

export const HeaderBlock = styled.div`
  ${FlexBetween}
  padding: var(--space-10) var(--space-10) var(--space-10) var(--space-16);
  gap: var(--space-32);
  border-bottom: 0.5px solid var(--border-primary);
  background: var(--background-secondary);
  position: sticky;
  top: 0;
  z-index: var(--z-index-header);
`;

export const LeftBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

export const ActionBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  .three-dot-icon {
    padding: var(--space-5);
    cursor: pointer;
    stroke: var(--text-secondary);
    &:hover {
      background: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
`;

export const TitleDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  p {
    ${Typography.body_lg_medium};
    color: var(--text-secondary);
    margin: var(--space-0);
  }
`;

export const EmptyStateWrapper = styled.div`
  .empty-state {
    z-index: var(--z-index-negative);
  }
`;
